import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getLeadNotes, createLeadNote } from '@/services/api';
import InternalNotesView from '@/components/collaboration/InternalNotesView';

export default function InternalNotesPanelLead({ leadId }: { leadId: string }) {
  const qc = useQueryClient();
  const [content, setContent] = useState('');

  const { data: notes, isLoading } = useQuery({
    queryKey: ['lead-notes', leadId],
    queryFn: () => getLeadNotes(leadId),
  });

  const addNote = useMutation({
    mutationFn: () => createLeadNote(leadId, content.trim(), 1),
    onSuccess: () => {
      setContent('');
      qc.invalidateQueries({ queryKey: ['lead-notes', leadId] });
    },
  });

  const sortedNotes = [...(notes ?? [])].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );

  const handleSubmit = () => {
    if (!content.trim() || addNote.isPending) {
      return;
    }
    addNote.mutate();
  };

  return (
    <InternalNotesView
      notes={sortedNotes.map((note) => ({
        id: note.noteId,
        content: note.content,
        createdAt: note.createdAt,
      }))}
      isLoading={isLoading}
      canCreate
      content={content}
      onContentChange={setContent}
      onSubmit={handleSubmit}
      isSubmitting={addNote.isPending}
      sticky
    />
  );
}
